import axios from 'axios';
import * as constants from "../Constatnts";


export function updateKOTStatus(key, status){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.put(
        `${constants.API_URL}/kot`,
        {
         key,
      status
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if(response.data.code=="0"){
        return true
      }
      return false
    }
    catch (error) {
      return false;
    }
  };
}


export function getKOTS(status)  {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/kot`,
        {
          params: {
            storeID: getState().user.store.key,
            status: status,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.orders;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

